/**
The main entry point for the Product ReviewsAll.

Referenced by the page.product-reviews.liquid template.
* */
import { Provider } from 'urql';
import ReactDOM from 'react-dom';
import graphqlClient from './utils/graphqlClient';
import ReviewsAll from './components/ReviewsAll';
import { jsx as _jsx } from "react/jsx-runtime";

var reviews = function reviews() {
  var urlParams = new URLSearchParams(window.location.search);
  var shopifyId = urlParams.get('product_id');
  var photos = urlParams.get('photos') === '1';

  if (shopifyId === null) {
    window.location.assign('/404');
    return;
  }

  var client = graphqlClient(urlParams);
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(ReviewsAll, {
      filterByPhotos: photos,
      queryLimit: 100,
      shopifyId: parseInt(shopifyId, 10)
    })
  }), document.getElementById('product-reviews'));
};

reviews();